<template>
  <div style="height: calc(100vh - 196px);">
    <vxe-toolbar id="toolbarId_sy93" :custom="{storage: true}" export :refresh="{query: RefreshList}">
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('plateformCompanyList_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button v-if="getLimit('plateformCompanyList_export_button')" @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />

      <vxe-table-column>
        <vxe-table-column field="groupName" title="企业名称" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.groupName" placeholder="请输入企业名称" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="groupNameLocal" title="企业简称" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.groupNameLocal" placeholder="请输入企业简称" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="level" title="所属组织" min-width="100" sortable :formatter="({ cellValue }) => formatterOptions(cellValue, 'status')" />
        <template v-slot:header>
          <el-select v-model="listQuery.level" placeholder="--请选择--" clearable>
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="address" title="联系地址" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.address" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column field="contactName" title="联系人" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.contactName" placeholder="请输入联系人" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column field="contactMobileTelephoneNumber" title="联系电话" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.contactMobileTelephoneNumber" placeholder="请输入电话" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="isAutomaticReport" title="自动上报" min-width="100" sortable :formatter="({ cellValue }) => formatterOptions(cellValue, 'isAutomaticReport')" />
        <template v-slot:header>
          <el-select v-model="listQuery.isAutomaticReport" placeholder="--请选择--" clearable>
            <el-option v-for="item in isAutomaticReportOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="gmtCreated" title="创建时间" min-width="260" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <!-- value-format="yyyy-MM-dd HH:mm:ss"
            default-time="['00:00:00', '23:59:59']" -->

      <vxe-table-column title="操作" fixed="right" min-width="290">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="账户明细" placement="top">
            <el-button v-if="getLimit('plateformCompanyList_account_button')" type="primary" size="mini" @click="accountDetail(scope.row.code)">
              账户明细
            </el-button>
          </el-tooltip>

          <el-tooltip v-if="getLimit('plateformCompanyList_detail_button')" class="item" effect="dark" content="详情" placement="top">
            <vxe-button type="text" @click="funOtherPage(scope.row,'detail')">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip v-if="getLimit('plateformCompanyList_edit_button')" class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text" @click="funOtherPage(scope.row,'edit')">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip v-if="getLimit('plateformCompanyList_report_button') && scope.row.code==branchCode && (loginkTarget==3 || loginkTarget==13 || loginkTarget ==18)" class="item" effect="dark" content="企业上报" placement="top">
            <vxe-button type="text" @click="report(scope.row.code)">
              <i class="el-icon-thumb" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip v-if="getLimit('plateformCompanyList_reportplay_button')&& scope.row.isAutomaticReport =='0'" class="item" effect="dark" content="自动上报开启" placement="top">
            <vxe-button type="text" @click="reportAuto(scope.row.code,'1')">
              <i class="el-icon-video-play" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip v-if="getLimit('plateformCompanyList_reportpause_button')&& scope.row.isAutomaticReport =='1'" class="item" effect="dark" content="自动上报关闭" placement="top">
            <vxe-button type="text" @click="reportAuto(scope.row.code,'0')">
              <i class="el-icon-video-pause" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "PlateformCompanyList",
  components: {},
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      exportObj:{
        exportUrl:"/ntocc-basic-api/partyGroup/exportPlateformCompanyList",//导出接口
        name:'平台企业'
      },
      listQuery: {
        gmtCreatedRange:'',
        code: "",
        level: "",
        groupName: "",
        groupNameLocal: "",
        telephone: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
      },
      branchCode: "",
      loginkTarget: 0,
      dataBranch: "",
      statusOptions: [
        { label: "根组织", value: '0' },
        { label: "子组织", value: '1' },
      ],
      isAutomaticReportOptions: [
        { label: "关闭", value: '0' },
        { label: "开启", value: '1' },
      ],
    };
  },
  created() {
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    this.loginkTarget =
      dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince ? dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince.configValue:0;
    this.branchCode = this.$store.state.user.party.branchCode;
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise((resolve) => {
        request({
          url: "/ntocc-basic-api/partyGroup",
          method: "get",
          params: this.listQuery,
        })
          .then((response) => {
     
            this.tableData = response.data.records;
            this.listQuery.total = response.data.total;
            this.loading = false;
            resolve();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    // 修改方法
    accountDetail(code) {
      this.$router.push({
        path: "/systemManage/plateformCompany/accountDetail",
        query: { code },
      });
    },
    funOtherPage(row, prefix) {
      this.$router.push({
        path: "/systemManage/plateformCompany/editPlateformCompany", 
        query: { code: row.code, level: row.level, prefix },
      });
    },
    report(code) {
      let loginkTargetObj = {
        3: "partrGroupJsReport",
        13: "partyGroupGdReport",
        18: "partyGroupLnReport",
      };
      let componentShow = loginkTargetObj[this.loginkTarget] || "";
      this.$router.push({
        path: "/systemManage/plateformCompany/enterpriseReport",
        query: { code, componentShow },
      });
    },
    async reportAuto(code,isAutomaticReport){
      const rLoading = this.openLoading();
      request({
          url: "/ntocc-basic-api/partyGroup/automaticReport",
          method: "put",
          params: {
            code: code,
            isAutomaticReport: isAutomaticReport,
          },
        })
        .then((response) => {
          rLoading.close();
          this.$message.success(response.msg)
          this.$store.dispatch('user/getInfo')
          this.findList()
        })
    },
    // 翻译
    formatterOptions(cellValue, prefix) {
      const item = this[`${prefix}Options`].find(item => item.value == cellValue)
      return item ? item.label : ''
    },
  },
};
</script>
